import React from "react";
import { clientLogos } from "../mock";

const ClientLogos = () => {
  const row = [...clientLogos, ...clientLogos, ...clientLogos, ...clientLogos];
  return (
    <section className="bg-[#ececec] py-14 overflow-hidden">
      <div className="relative pause-on-hover">
        <div className="flex w-max animate-marquee-left" style={{ "--marquee-duration": "28s" }}>
          {row.map((logo, i) => (
            <div key={i} className="flex items-center justify-center px-12 shrink-0">
              <img
                src={logo}
                alt="client"
                className="h-7 w-auto opacity-40 grayscale hover:opacity-70 transition-opacity"
              />
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#ececec] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#ececec] to-transparent" />
      </div>
    </section>
  );
};

export default ClientLogos;
